<div class="login-split">
  <!-- Brand panel -->
  <aside class="login-brand">
    <div class="login-brand-inner">
      <div class="login-lockup">
        <img src="assets/logo/zelustech-logo-only-cream-orange.svg" alt="" class="login-mark" />
        <span class="login-wordmark">ZelusHR</span>
      </div>

      <div class="login-brand-body">
        <h2 class="login-headline">{{ headline }}</h2>
        <p class="login-brand-sub">Sign in to manage your people, pay, and time.</p>
      </div>

      <p class="login-trust">
        <lucide-icon [img]="icons.shieldCheck" [size]="16" />
        Your data is encrypted in transit and at rest
      </p>
    </div>
  </aside>

  <!-- Form panel -->
  <section class="login-panel">
    <div class="login-form-wrap">
      <header class="login-head">
        <h1 class="login-title">Welcome back</h1>
        <p class="login-subtitle">Sign in to your ZelusHR account.</p>
      </header>

      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="submit()">
        @if (errorTxt) {
          <div class="login-error">
            <app-client-response-errors [errorTxt]="errorTxt"></app-client-response-errors>
          </div>
        }

        <div class="zh-form-group">
          <label class="zh-form-label" for="login-username">Username</label>
          <div class="login-field">
            <lucide-icon class="login-field-icon" [img]="icons.user" [size]="18" />
            <input
              #usernameInput
              id="login-username"
              type="text"
              formControlName="username"
              class="zh-input"
              autocomplete="username"
              [class.is-invalid]="
                loginForm.controls['username'].touched && loginForm.controls['username'].errors
              "
              [attr.aria-invalid]="
                loginForm.controls['username'].touched && loginForm.controls['username'].errors
                  ? true
                  : null
              "
              [attr.aria-describedby]="
                loginForm.controls['username'].touched && loginForm.controls['username'].errors
                  ? 'login-username-error'
                  : null
              "
            />
          </div>
          @if (loginForm.controls['username'].touched && loginForm.controls['username'].errors) {
            <div id="login-username-error" class="zh-validation-message error">
              Enter your username.
            </div>
          }
        </div>

        <div class="zh-form-group">
          <label class="zh-form-label" for="login-password">Password</label>
          <div class="login-field login-field-reveal">
            <lucide-icon class="login-field-icon" [img]="icons.lock" [size]="18" />
            <input
              id="login-password"
              [type]="showPassword() ? 'text' : 'password'"
              formControlName="password"
              class="zh-input"
              autocomplete="current-password"
              [class.is-invalid]="
                loginForm.controls['password'].touched && loginForm.controls['password'].errors
              "
              [attr.aria-invalid]="
                loginForm.controls['password'].touched && loginForm.controls['password'].errors
                  ? true
                  : null
              "
              [attr.aria-describedby]="
                loginForm.controls['password'].touched && loginForm.controls['password'].errors
                  ? 'login-password-error'
                  : null
              "
            />
            <button
              type="button"
              class="login-field-reveal-btn"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showPassword()"
              (click)="showPassword.set(!showPassword())"
            >
              <lucide-icon [img]="showPassword() ? icons.eyeOff : icons.eye" [size]="18" />
            </button>
          </div>
          @if (loginForm.controls['password'].touched && loginForm.controls['password'].errors) {
            <div id="login-password-error" class="zh-validation-message error">
              Enter your password.
            </div>
          }
        </div>

        <button
          class="zh-btn zh-btn-primary login-submit-btn"
          type="submit"
          [appZhLoading]="submitting()"
          [attr.aria-busy]="submitting()"
        >
          Sign in
        </button>

        <p class="login-help">Trouble signing in? Contact your administrator.</p>
      </form>
    </div>
  </section>
</div>

<p-dialog
  header="Choose Company"
  [visible]="companySelectionDialogVisible()"
  (visibleChange)="$event ? companySelectionDialogVisible.set(true) : cancelCompanySelection()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '28rem' }"
  position="top"
>
  <form>
    <div class="zh-form-group">
      <label class="zh-form-label" for="login-company-select">Company</label>
      <p-select
        inputId="login-company-select"
        [options]="companies()"
        [formControl]="userCompanySelect"
        optionLabel="name"
        optionValue="companyId"
        placeholder="Select company"
        [filter]="true"
        filterPlaceholder="Type to search"
        appendTo="body"
        styleClass="w-100 select-normal"
        class="select-normal"
      ></p-select>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button type="button" class="zh-btn zh-btn-secondary me-1" (click)="cancelCompanySelection()">
      Cancel
    </button>
    <button
      type="button"
      class="zh-btn zh-btn-primary"
      [appZhLoading]="submitting()"
      [attr.aria-busy]="submitting()"
      (click)="selectCompany()"
    >
      Select Company
    </button>
  </ng-template>
</p-dialog>
